import PropTypes from 'prop-types'

const BookHalf = ({
  width = '16',
  height = '16',
  color = 'currentColor',
  className = '',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill={color}
    className={`bi bi-book-half ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8.5 2.687c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 2.192c-.84-.922-2.208-1.234-3.814-1.075C2.522 1.273.596 2.187 0 2.686v9.923c.596-.499 2.522-1.413 4.186-1.57 1.372-.131 2.907.062 3.814 1.207V2.192zm13 10.618V2.233c-1.09-.23-2.5-.566-3.814-.634-2.046-.106-3.252.402-3.186 1.388V13c.632-.501 2.158-1.112 3.814-.981 1.372.11 2.907.487 3.186 1.399z" />
  </svg>
)

BookHalf.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
}

export default BookHalf
